import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

enum OrderHistoryAction {
  MANUAL_SUBMISSION_ALLOWED = "manual-submission-allowed",
  MANUAL_RESULTING_ALLOWED = "manual-resulting-allowed",
  TRIAGE_ALLOWED = "triage-allowed",
  MARK_DISCUSSED_ALLOWED = "mark-discussed-allowed",
}

interface AvailableOrderHistoryAction {
  action: OrderHistoryAction;
  available: boolean;
}

interface AvailableOrderHistoryActionsResponse {
  availableActions: AvailableOrderHistoryAction[];
}

type OrderHistoryActions = {
  manualSubmissionAllowed: boolean;
  manualResultingAllowed: boolean;
  triageAllowed: boolean;
  markDiscussedAllowed: boolean;
};

export const useOrderResultHistoryAvailableActions = (patientId: string) => {
  return useApi<AvailableOrderHistoryActionsResponse, OrderHistoryActions>({
    queryOptions: {
      queryKey:
        QueryKeys.Patient.MedicalRecords.Labs.ORDER_HISTORY_AVAILABLE_ACTIONS(
          patientId,
        ),
      queryFn: async () => {
        const response = await axiosInstance.get(
          "/labs/order/order-history-available-actions",
        );
        return response?.data;
      },
      select: (data) => {
        const actions = data.availableActions.reduce((acc, item) => {
          if (item.action === OrderHistoryAction.MANUAL_SUBMISSION_ALLOWED) {
            acc.manualSubmissionAllowed = item.available;
          } else if (
            item.action === OrderHistoryAction.MANUAL_RESULTING_ALLOWED
          ) {
            acc.manualResultingAllowed = item.available;
          } else if (item.action === OrderHistoryAction.TRIAGE_ALLOWED) {
            acc.triageAllowed = item.available;
          } else if (
            item.action === OrderHistoryAction.MARK_DISCUSSED_ALLOWED
          ) {
            acc.markDiscussedAllowed = item.available;
          }
          return acc;
        }, {} as OrderHistoryActions);
        return actions;
      },
    },
  });
};
